import React from 'react';
import { X, Star, Sparkles, Camera, Heart, Users, Image } from 'lucide-react';
interface DickpicRatingUpsellProps {
  onClose: () => void;
  onSelect?: (tier: number, price: number) => void;
}
export const DickpicRatingUpsell: React.FC<DickpicRatingUpsellProps> = ({
  onClose,
  onSelect
}) => {
  const tiers = [{
    id: 1,
    name: 'Basic Rating',
    price: 15,
    description: 'A short opinion from your Angel about your pic 😘',
    icon: <Star className="text-yellow-400" size={24} data-id="element-6671" />,
    color: 'from-blue-600 to-purple-600'
  }, {
    id: 2,
    name: 'Spicy Rating',
    price: 45,
    description: "She'll tell you what she wants to do with it… and show you something in return 🔥",
    icon: <Sparkles className="text-pink-400" size={24} data-id="element-6672" />,
    color: 'from-pink-600 to-purple-600',
    popular: true
  }, {
    id: 3,
    name: 'XXXL Fantasy Rating',
    price: 90,
    description: 'She AND her girlfriends will share their wildest fantasies about your member 😈💦 Includes AI-generated pic fantasy preview.',
    icon: <Users className="text-purple-400" size={24} data-id="element-6673" />,
    color: 'from-purple-600 to-indigo-600'
  }];
  return <div className="p-6 bg-white dark:bg-gray-950 rounded-xl text-gray-800 dark:text-white shadow-md" data-id="element-6674">
      <div className="flex justify-between items-center mb-4" data-id="element-6675">
        <h2 className="text-xl font-bold" data-id="element-6676">Choose Your Rating Experience</h2>
        <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-6677">
          <X size={20} data-id="element-6678" />
        </button>
      </div>
      <p className="text-gray-600 dark:text-gray-400 mb-6" data-id="element-6679">
        Get personalized feedback on your intimate pics from your Angel
      </p>
      <div className="space-y-4" data-id="element-6680">
        {tiers.map(tier => <div key={tier.id} onClick={() => onSelect && onSelect(tier.id, tier.price)} className={`relative p-4 rounded-lg border cursor-pointer transition-all hover:shadow-lg ${tier.popular ? 'border-pink-500 bg-gradient-to-br from-pink-50 to-purple-50 dark:from-gray-900 dark:to-gray-800' : 'border-gray-200 bg-gray-50 hover:border-gray-300 dark:border-gray-700 dark:bg-gray-900 dark:hover:border-gray-500'}`} data-id="element-6681">
            {tier.popular && <div className="absolute -top-3 -right-2 bg-pink-500 text-white text-xs px-3 py-1 rounded-full" data-id="element-6682">
                Most Popular
              </div>}
            <div className="flex items-start" data-id="element-6683">
              <div className={`p-3 rounded-full bg-gradient-to-br ${tier.color} mr-4`} data-id="element-6684">
                {tier.icon}
              </div>
              <div className="flex-1" data-id="element-6685">
                <h3 className="font-bold text-lg" data-id="element-6686">{tier.name}</h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm mt-1" data-id="element-6687">
                  {tier.description}
                </p>
                <div className="mt-3 flex justify-between items-center" data-id="element-6688">
                  <span className="text-xl font-bold" data-id="element-6689">{tier.price} 💎</span>
                  <button className={`px-4 py-2 rounded-full text-white bg-gradient-to-r ${tier.color}`} data-id="element-6690">
                    Select
                  </button>
                </div>
              </div>
            </div>
          </div>)}
      </div>
      <div className="mt-6 text-center text-xs text-gray-500" data-id="element-6691">
        <p data-id="element-6692">
          All ratings are private and confidential. Your Angel will never share
          your pictures.
        </p>
      </div>
    </div>;
};